import type {Part} from 'schemaDefinition/types';
import type {
  AgentCorporation,
  AgentEvent,
  AgentPerson,
} from 'services/agent/types';

type BareAgent = Pick<
  AgentPerson | AgentCorporation | AgentEvent,
  'isni' | 'nationalId'
>;

export const agentBAREParts: Part<BareAgent>[] = [
  {
    type: 'text',
    name: 'isni',
    editToggle: true,
    actions: ['copy'],
  },
  {
    type: 'text',
    name: 'nationalId',
    prefix: 'icon:Verified',
    prefixOnEmpty: 'icon:None',
    editToggle: true,
    actions: ['copy'],
  },
];
